export const state = {
    variablePixelData: [],
    pixelDataLast: null,

    pixelDataHis: [],

    pixelDataLoading: false,
};